import {Injectable} from '@angular/core';
import {CryptoService} from './crypto.service';
import {AppComponent} from "../app.component";

class LocalStorage implements Storage {
    [name: string]: any;
    readonly length: number;
    clear(): void {}
    getItem(key: string): string | null {return undefined;}
    key(index: number): string | null {return undefined;}
    removeItem(key: string): void {}
    setItem(key: string, value: string): void {}
}

@Injectable({providedIn: 'root'})
export class BrowserStorageService {

    private storage: Storage;

    constructor(private cryptoService: CryptoService) {
        this.storage = new LocalStorage();

        AppComponent.isBrowser.subscribe(isBrowser => {
            if (isBrowser) {
                this.storage = localStorage;
            }
        });
    }

    removeLocalStorageValue(key: string) {
        this.storage.removeItem(key);
    }

    setLocalStorageValue(key: string, obj: any): void {
        this.setStorageValue(key, obj, this.storage);
    }

    getLocalStorageValue(key: string): any {
        return this.getStorageValue(key, this.storage);
    }

    private setStorageValue(key: string, obj: any, storage: any) {
        storage.setItem(key, this.cryptoService.encrypt(JSON.stringify(obj)));
    }

    private getStorageValue(key: string, storage: any): any {
        let stringEncrypted = storage.getItem(key);
        if (stringEncrypted) {
            let stringDecrypted: string = this.cryptoService.decrypt(stringEncrypted);
            try {
                let obj: any = JSON.parse(stringDecrypted);
                return obj;
            } catch (e) {}
        }
        return null;
    }
}
